import React from "react";
import { Link } from "react-router";
import {
  Type,
  FormInput,
  LayoutGrid,
  MessageSquare,
  PanelLeft,
  Layers,
  Puzzle,
  KeyRound,
  Plug,
  Upload,
} from "lucide-react";

import { ADMIN_ROUTES } from "@/shared/constants/paths";

const sections = [
  {
    title: "Foundation",
    description: "Typography, fonts, and text styles",
    path: ADMIN_ROUTES.STYLE_GUIDE_FOUNDATION,
    icon: Type,
  },
  {
    title: "Form Controls",
    description: "Buttons, inputs, selects, and other form elements",
    path: ADMIN_ROUTES.STYLE_GUIDE_FORM_CONTROLS,
    icon: FormInput,
  },
  {
    title: "Data Display",
    description: "Badges, cards, tables, and progress indicators",
    path: ADMIN_ROUTES.STYLE_GUIDE_DATA_DISPLAY,
    icon: LayoutGrid,
  },
  {
    title: "Feedback",
    description: "Alerts and toast notifications",
    path: ADMIN_ROUTES.STYLE_GUIDE_FEEDBACK,
    icon: MessageSquare,
  },
  {
    title: "Layout",
    description: "Tabs, accordions, and content organization",
    path: ADMIN_ROUTES.STYLE_GUIDE_LAYOUT,
    icon: PanelLeft,
  },
  {
    title: "Overlays",
    description: "Dialogs, sheets, popovers, and tooltips",
    path: ADMIN_ROUTES.STYLE_GUIDE_OVERLAYS,
    icon: Layers,
  },
  {
    title: "Custom",
    description: "Application-specific components",
    path: ADMIN_ROUTES.STYLE_GUIDE_CUSTOM,
    icon: Puzzle,
  },
  {
    title: "Upload",
    description: "Upload zones, file cards, dialogs, and upload steps",
    path: ADMIN_ROUTES.STYLE_GUIDE_UPLOAD,
    icon: Upload,
  },
  {
    title: "Auth",
    description: "Authentication flows and verification",
    path: ADMIN_ROUTES.STYLE_GUIDE_AUTH,
    icon: KeyRound,
  },
  {
    title: "Integrations",
    description: "Third-party API testing (Enformion, Tracers)",
    path: ADMIN_ROUTES.STYLE_GUIDE_INTEGRATIONS,
    icon: Plug,
  },
];

const StyleGuideIndexPage: React.FC = () => {
  return (
    <div className="w-full px-12 py-12">
      <header className="mb-12">
        <p className="mb-1 text-sm font-medium text-brand">Design System</p>
        <h1 className="mb-3 font-sans text-2xl font-bold tracking-tight">Style Guide</h1>
        <p className="text-sm leading-relaxed text-secondary">
          A comprehensive reference for all UI components, typography, and design patterns used
          throughout the Elayne platform.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2">
        {sections.map((section) => (
          <Link
            key={section.path}
            to={section.path}
            className="group no-underline rounded-lg border border-primary p-5 transition-all hover:border-brand/30 hover:bg-brand-subtle"
          >
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-subtle text-brand">
              <section.icon className="h-5 w-5" />
            </div>
            <h2 className="mb-1 font-sans text-base font-semibold group-hover:text-brand">
              {section.title}
            </h2>
            <p className="text-sm text-secondary">{section.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default StyleGuideIndexPage;
